module.exports = __webpack_public_path__ + "img/plus_btn.693c231b.png";